import { jsx as _jsx } from "react/jsx-runtime";
import { classNames } from "../../utilities/props.js";
import s from "./Badge.module.css";
const BadgeContainer = (props) => {
    const { children, position = "top-end", overlap, className, attributes } = props;
    const rootClassNames = classNames(s.container, className, overlap && s["--container-overlap"], position && s[`--container-position-${position}`]);
    return (_jsx("div", { ...attributes, className: rootClassNames, children: children }));
};
BadgeContainer.displayName = "Badge.Container";
export default BadgeContainer;
